import React, { useState } from "react";
import Modal from "../Modal";
import ModalBuscarVendedor from "./ModalBuscarVendedor";

const VendedorSelector = ({ onSelectVendedor, selectedVendedorInitial = null }) => {
    const [showSearchVendedor, setShowSearchVendedor] = React.useState(false);
    const [selectedVendedor, setSelectedVendedor] = React.useState(selectedVendedorInitial);

    React.useEffect(() => {
        if (selectedVendedorInitial && (!selectedVendedor || selectedVendedorInitial.IdVendedor !== selectedVendedor.IdVendedor)) {
            setSelectedVendedor(selectedVendedorInitial);
        }
    }, [selectedVendedorInitial]);

    const handleSelectVendedor = (v) => {
        setSelectedVendedor(v);
        setShowSearchVendedor(false);
        if (onSelectVendedor) {
            onSelectVendedor(v);
        }
    };

    const getDisplayValue = () => {
        if (!selectedVendedor) return "";
        if (selectedVendedor.NroDocumento) {
            return `${selectedVendedor.NroDocumento} - ${selectedVendedor.RazonSocial}`;
        }
        return selectedVendedor.RazonSocial || selectedVendedor.Vendedor || "";
    };

    return (
        <>
            <div className="form-group-custom" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                <input
                    type="text"
                    className="form-input-custom"
                    placeholder="Seleccionar Vendedor"
                    value={getDisplayValue()}
                    readOnly
                    onClick={() => setShowSearchVendedor(true)}
                    style={{
                        paddingRight: '40px',
                        borderColor: selectedVendedor ? '#28a745' : '#009688',
                        backgroundColor: selectedVendedor ? '#f0fff4' : 'white',
                        fontWeight: selectedVendedor ? '600' : 'normal',
                        cursor: 'pointer'
                    }}
                />
                <div style={{ position: 'absolute', right: '15px', display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <button
                        type="button"
                        onClick={() => setShowSearchVendedor(true)}
                        title="Buscar vendedor"
                        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#009688', padding: 0, fontSize: '1.2rem' }}
                    >
                        <i className="fas fa-search"></i>
                    </button>
                </div>
            </div>

            <Modal
                title="BUSCAR VENDEDOR"
                isOpen={showSearchVendedor}
                onClose={() => setShowSearchVendedor(false)}
            >
                <ModalBuscarVendedor
                    onSelectVendedor={handleSelectVendedor}
                />
            </Modal>
        </>
    );
};

export default VendedorSelector;
